class ValidationCheck {
    constructor({ isValid = true, error = null } = {}) {
        this.isValid = isValid;
        this.error = error;
    }
}

export default ValidationCheck;
